module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-2x1-183f41c85026ce65fee3b0679be54e45.jpg";